/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';
import './Gallery.css'; // Import CSS for styling

const Gallery = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const images = [
    '/images/gamenight3.jpg',
    '/images/gamenight5.jpg',
    '/images/bakesale1.jpeg',
    '/images/gamenight7.jpg',
    '/images/gamenight8.jpg',
    '/images/ps1.jpg',
    '/images/ps2.jpg',
    '/images/ps3.jpg',
    '/images/ps4.jpg',
    '/images/ps5.jpg',
    '/images/ps6.jpg',
    '/images/ps7.jpg',
    '/images/ps8.jpg',
    '/images/eb1.jpg',
    '/images/eb2.jpg',
    '/images/eb3.jpg',
    '/images/eb4.jpg',
    '/images/ev1.jpg',
    '/images/ev2.jpg',
    '/images/ev3.png',
    '/images/ev4.jpg',
    '/images/ev5.jpg',
  ];

  // Open the modal and set the selected image
  const openModal = (index) => {
    setSelectedImageIndex(index);
    document.body.style.overflow = 'hidden'; // Prevent page scrolling when modal is open
  };

  // Close the modal and reset the selected image
  const closeModal = () => {
    setSelectedImageIndex(null);
    document.body.style.overflow = ''; // Re-enable page scrolling
  };

  // Go to the next image
  const nextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Go to the previous image
  const prevImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Gallery</h1>

      <div className="gallery-grid">
        {images.map((image, index) => (
          <div className="gallery-item" key={index} onClick={() => openModal(index)}>
            <img
              src={image}
              alt={`Gallery Item ${index + 1}`}
              className="gallery-image"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      {selectedImageIndex !== null && (
        <div className="modal-overlay active" onClick={closeModal}>
          <div className="modal-content active" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
            <button className="modal-nav prev" onClick={prevImage}>
              &#10094;
            </button>
            <img
              src={images[selectedImageIndex]}
              alt={`${selectedImageIndex + 1}`}
              className="modal-image"
            />
            <button className="modal-nav next" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
